import { useEffect } from "react";
import { useSelector } from "react-redux";

import { getLocation } from "../../ducks/location/selectors";
import { usePresentationMode } from "./usePresentationMode";
import { RoutePanelName } from "../../appConfig/types";

export const useInitPresentationMode = () => {
  const location = useSelector(getLocation);
  const { togglePresentationMode } = usePresentationMode();

  useEffect(() => {
    if (location.payload.panel === RoutePanelName.Presentation) {
      togglePresentationMode();
    }
  }, []);
};
